import React from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

export default class IndexCallClaim extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { data, claimCall, currentlyEditing } = this.props;

    let unconfirmedReservations = data.unconfirmed_reservations || [];

    let call,
      earnings,
      totalEarnings,
      timeToComplete,
      ttcHours,
      ttcMins,
      reservationExpiration;

    if (unconfirmedReservations.length > 0) {
      call = unconfirmedReservations[0];
      earnings = call.earnings.map(earning => earning.toFixed(2));
      totalEarnings = call.earnings.map(earning =>
        ((earning * call.call_length_sec_of_human_transcribed_events) / 60).toFixed(2)
      );
      timeToComplete = call.expiration_period_sec / 60;
      ttcHours = Math.floor(timeToComplete / 60);
      ttcMins = Math.round(timeToComplete % 60);
      reservationExpiration = Math.round(call.reservation_expiration_sec / 60);
    }

    return (
      <Card body>
        {unconfirmedReservations.length === 0 ? (
          <>
            <h1 className="large">Call Reservation</h1>
            <p>Number of claims: {Infinity}</p>
            <p>
              When we find a call for you it will appear here! Once a call has
              been reserved you will only have 30 minutes to begin working on it
              before it is released!
            </p>
          </>
        ) : (
          <>
            <h1 className="large">We Found a Call!</h1>
            <p>
              Call {call.display_id} has been claimed for you! You have{" "}
              {reservationExpiration} minutes to begin working on this call.
              {currentlyEditing.length > 0
                ? " Submit your current transcript to begin!"
                : ""}
            </p>
            <p>Description:</p>
            <p>
              Audio to Transcribe: {(call.call_length_sec_of_human_transcribed_events / 60).toFixed(2)} minutes
            </p>
            <p>
              Per Minute Rate: ${earnings.join('/')}
            </p>
            <p>
              Estimated Earning: ${totalEarnings.join('/')}
            </p>
            <p>
              Time Allowed to Complete Call: {ttcHours + " hours "}
              {ttcMins + " minutes"}
            </p>
            {currentlyEditing.length > 0 ? (
              <p>
                Make sure you finish this call before your request returns a new
                one! You can only transcribe one call at a time and if your
                reservation expires before you can claim it then you will lose
                the reserved call!
              </p>
            ) : (
              <p>
                You may now submit another reservation request. Just make sure
                that you’ll be finished with your call in time! You can only
                transcribe one call at a time and if your reservation expires
                before you can claim it then you will lose the reserved call.
              </p>
            )}
            <Button
              variant="success"
              onClick={() =>
                claimCall(call.display_id, call.transcribe_claim_jwt)
              }
              disabled={currentlyEditing.length > 0}
            >
              Start Editing
            </Button>
          </>
        )}
      </Card>
    );
  }
}
